import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import GasOrdDetailsView from './details';
import GasOrdsListView from './list';
export default angular.module('app.gas.ords', [])
    .config(routes)
    .component("gasOrdDetailsView", react2angular(GasOrdDetailsView, [], ["$state", "GasService", "UIService"]))
    .component("gasOrdsListView", react2angular(GasOrdsListView, [], ["$state", "GasService"]))
    .name;
